// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"03a7e261","539":"e6f1e71f","545":"9611ba12","669":"ad994635","706":"1544ce4a","787":"b7cb626b"}[chunkId] + ".chunk.js";
};